import { Tooltip, Button } from "@mui/material"
import { appBarButtonStyle } from "../Graphics"
import { useState } from "react"
import UIContentImportDialog from "./UIContentImportDialog"

type Props = {
  updateApp: Function,
  text?: string,
}
  
export default function UIButtonImport({updateApp, text}: Props){
  const buttonText = text ? text: 'IMPORT'
  const [importOpen, setImportOpen] = useState(false)
  const toggleImportOpen = (open: boolean) => (event: React.MouseEvent) => {
    setImportOpen(open)
  }
  
  return(
    <>
      <Tooltip arrow title='Load content from JSON file'>
        <Button variant='outlined' color='inherit' sx={appBarButtonStyle} component="label" onClick={toggleImportOpen(true)}>
          {buttonText}
        </Button>
      </Tooltip>
      <UIContentImportDialog isOpen={importOpen} closeDialog={toggleImportOpen(false)} updateApp={updateApp}/>
    </>
  )
}